import React, { useEffect } from "react";
import AppRoutes from "./routes/routes";
import BlockNavigation from "./routes/usePrompt";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { authenticateActions } from "./store/store"; 
import NapidAuthAPI from "./api/napidAuthApi.mjs";

function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.auth.accessToken);

  const handleConfirmLogout = async () => {
    try {
      await NapidAuthAPI.logoutUser(accessToken);
    } catch (error) {
      console.error(
        "Logout API failed (may be ignored during tab close):",
        error
      );
    }

    localStorage.clear();
    sessionStorage.clear();
    dispatch(authenticateActions.logout());
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    // Detect if this is a page reload (not tab close/open)
    const isPageReload =
      performance.navigation.type === 1 || // old way
      performance.getEntriesByType("navigation")[0]?.type === "reload"; // modern way

    if (isPageReload) {
      // Logout on manual refresh
      handleConfirmLogout();
    }

    const handleUnload = () => {
      // Don't logout here anymore if you want to persist on tab close
      // Just optional cleanup
    };

    window.addEventListener("unload", handleUnload);

    return () => {
      window.removeEventListener("unload", handleUnload);
    };
  }, []);

  return (
    <div>
      <BlockNavigation />
      <AppRoutes />
    </div>
  );
}

export default App;
